import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { BreakPoint } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

const MemberCard = ({ image, name, position, description, ...props }) => (
  <Card {...props}>
    {image && <Thumbnail src={image} />}
    <Introduction>
      <Name as="h3">{name}</Name>
      <Position as="p" css={positionCss}>
        {position}
      </Position>
      <Description as="p" css={descriptionCss}>
        {description}
      </Description>
    </Introduction>
  </Card>
)

const Card = styled.div`
  width: 100%;
  border: 1px solid #ededed;
  background-color: #ffffff;
`

const Thumbnail = styled.img`
  width: 100%;
`

const Text = styled(Typography)`
  color: #333;
  letter-spacing: 0.07em;
`

const Introduction = styled.div`
  padding: 24px 16px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    padding: 24px 16px 30px;
  }
`

const Name = styled(Text)`
  font-weight: bold;
  font-size: 18px;
  line-height: 1.5;
`

const positionCss = css`
  margin-top: 8px;
`

const Position = styled(Text)`
  font-size: 12px;
  line-height: 1.4;
`

const Description = styled(Text)`
  font-size: 14px;
  line-height: 1.4;
`

const descriptionCss = css`
  margin-top: 24px;
`

export default MemberCard
